module.exports = __webpack_public_path__ + "img/mastercard.58673f61.png";